import useDialog from './useDialog'
import { EditUserProps } from '../components/dialogs/User/EditUser'

const useCreateUserDialog = () => useDialog<EditUserProps>('edit-user')

export default useCreateUserDialog
